import React from 'react';
import { Listing } from 'models/Listing';
import { checkIsTierPlatinum, checkIsUrgent } from 'utils';
import PremiumListingCard from 'components/PremiumListingCard';
import DistressedListingCard from 'components/DistressedListingCard';
import ListingCard from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/ListingCard';

type CorrectTierCardProps = {
  listing: Listing;
  updateListing: (listingId: string, updatedValues: Partial<Listing>) => void;
};

const CorrectTierCard: React.FC<CorrectTierCardProps> = ({
  listing,
  updateListing,
}) => {
  const { _id, tier, type } = listing;

  const CorrectTierCard = checkIsTierPlatinum(tier)
    ? PremiumListingCard
    : checkIsUrgent(type)
    ? DistressedListingCard
    : ListingCard;

  return (
    <CorrectTierCard
      key={_id}
      listing={listing}
      onWatchlisted={(isWatchlisted) => updateListing(_id, { isWatchlisted })}
    />
  );
};

export default CorrectTierCard;
